export const EXPORT_PRODUCTION_CONTROL_SHEET = (
  begin_date,
  end_date,
  team_id,
  csys_registration_number
) =>
  `/export_production_control_sheet/?${begin_date}${end_date}${team_id}${csys_registration_number}`;
